(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/bottomsheet/bottomsheet.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/bottomsheet/bottomsheet.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const bottomSheetMaxWidth = '500px';
const bottomSheetOverlapPx = -6;
const bottomSheetShadow = '0 -6px 10px -5px rgba(0, 0, 0, 0.05), 0 -6px 12px 2px rgba(0, 0, 0, 0.05), 0 -6px 12px 5px rgba(0, 0, 0, 0.05)';
const bottomSheetStyle = {
  zIndex: 1,
  position: 'fixed',
  left: '50%',
  bottom: 0,
  transform: 'translateX(-50%)',
  width: '100%',
  maxWidth: bottomSheetMaxWidth,
  backgroundColor: '#fff',
  marginBottom: "".concat(bottomSheetOverlapPx, "px"),
  borderTopLeftRadius: '12px',
  borderTopRightRadius: '12px',
  boxShadow: bottomSheetShadow,
  pointerEvents: 'auto'
};
const bottomSheetTitleStyle = {
  margin: 0,
  padding: '12px 16px 8px',
  textAlign: 'center',
  fontSize: '20px',
  lineHeight: '24px',
  fontWeight: 500,
  color: '#001932'
};
const BottomSheet = _ref => {
  let children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    title = _ref.title;
  return React.createElement("div", {
    className: className,
    style: _objectSpread(_objectSpread({}, bottomSheetStyle), style)
  }, title && React.createElement("p", {
    style: bottomSheetTitleStyle
  }, title), children);
};
setGlobal('svs.tickets.next.components.bottomsheet.BottomSheet', BottomSheet);

 })(window);